import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import brands from "../Json/Brand.json";
import SubCategory from "../Json/SubCategory.json";
import { useDispatch } from "react-redux";
import DownloadModal from "./Modals/DownloadModal";
import {
  CheckSoldItems,
  SetBottomSizeFilter,
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
  getAllProductOnline,
  getLastDoc,
} from "../features/Products/ProductSlice";
import { SetSearch } from "../features/TopSearches/TopSearchesSlice";

function MegaMenu({ setHoverMenu }) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [hide, setHide] = useState(false);
  const [show, setShow] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [activeFilter, setActiveFilter] = useState(null);
  const isMobile = width <= 768;
  const BecomeSeller = async (id) => {
    if (isMobile) {
      window.location.assign("https://libas.page.link/welcome");
      //navigator("https://libas.page.link/cart");
    } else {
      setShow(true);
    }
  };
  const dispatch = useDispatch();
  function selectedPageNull() {
    dispatch(SetSizeFilter([]));
    dispatch(SetTopSizeFilter([]));
    dispatch(SetBottomSizeFilter([]));
    dispatch(getAllProductOnline([]));
    dispatch(getLastDoc(null));
    dispatch(SetSelectdPage(0));
    dispatch(SetSearch(""));
  }

  const BrandsSection = [
    { id: "UXo5X4BP3lMoimmkMNrO" },
    { id: "nMmJX9z74ZJy98M4zse4" },
    { id: "9euIqdADV2sXs49OoXIs" },
    { id: "k2mIsRr2C2Jax6TlitBG" },
    { id: "YETcI5UACzR21ktVty4G" },
    { id: "htjMB0lyqYD7dqviSd58" },
    { id: "RiE6OzHvJgxyrv0PjE3G" },
    { id: "HOg0VXl7VqKzDg7wqn52" },
    { id: "NAHb0mOIuEtPZcqMAn94" },
    { id: "SQImHuAPQcivU49D9Obf" },
  ];
  const BrandsSection2 = [
    { id: "MJSVOzPBi2vsGFu55Y7A" },
    { id: "Dzr5aum2QhF8h8rDMyrw" },
    { id: "6gCg1qU5mt67YBafPupL" },
    { id: "1qzwoL33uzzcKF9rlSrP" },
    { id: "CEjaAw6tesKQhzGBnkZe" },
    { id: "bsDmPUaLYKPCwoxLlTw0" },
    { id: "k1MUggevPUVeP4OdQA3K" },
    { id: "brvXCtEhGyu3rUs9VrcT" },
    { id: "I3Nr0lHpoWrYxLw5nzsf" },
    { id: "a6FVMVxnhctfJprZmzzK" },
  ];
  const BrandsSection3 = [
    { id: "XfeeY5SoK8Ez16rAzJaH" },
    { id: "n3zJLouTWNwZnfToQxtI" },
    { id: "ng1wdK8d3lF6il3VQGae" },
    { id: "85oOOzNJVd2ArnTSJJYw" },
    { id: "gx48EN58tk80Kcwgl1xY" },
    { id: "vsUMeHPID1Rs7QdZiHD3" },
    { id: "i2u0Wg3fhUIrtsWegpsM" },
    { id: "iBJgqgPm9in6WB4B5aG1" },
  ];
  // const WatchBrandsSection = [
  //   { id: "QAw7MDbzMROqHrCuLfpi" },

  //   { id: "CEjaAw6tesKQhzGBnkZe" },

  //   { id: "RiE6OzHvJgxyrv0PjE3G" },

  //   { id: "htjMB0lyqYD7dqviSd58" },

  //   { id: "gx48EN58tk80Kcwgl1xY" },

  //   { id: "mQaMXzznjUirDmeCyPmb" },

  //   { id: "mveL4svGPaLOzcxmR6f6" },

  //   { id: "O4G4nvso5z7IDQOsxvZh" },
  //   { id: "NAHb0mOIuEtPZcqMAn94" },
  //   { id: "mveL4svGPaLOzcxmR6f6" },
  //   { id: "mveL4svGPaLOzcxmR6f6" },

  //   { id: "brvXCtEhGyu3rUs9VrcT" },

  //   { id: "9euIqdADV2sXs49OoXIs" },

  //   { id: "lX3ZPQbSWauxgVTKRJzW" },
  // ];
  const watchBrandsSection = [
    { id: "Breitling" },
    { id: "Burberry" },
    { id: "Cartier" },
    { id: "Chanel" },
    { id: "Gucci" },
    { id: "Hermès" },
    { id: "Hublot" },
    { id: "Longines" },
    { id: "Louis Vuitton" },
    { id: "Michael Kors" },
    { id: "Omega" },
    { id: "Rolex" },
    { id: "Tag Heuer" },
    { id: "Yves Saint Laurent" },
  ];

  const jewelryBrandsSection = [
    { id: "Cartier" },
    { id: "Céline" },
    { id: "Chanel" },
    { id: "Christian Dior" },
    { id: "Dior" },
    { id: "Fendi" },
    { id: "Givenchy" },
    { id: "Gucci" },
    { id: "Hermès" },
    { id: "Kate Spade" },
    { id: "Louis Vuitton" },
    { id: "Tiffany & Co" },
    { id: "Van Cleef & Arpels" },
    { id: "Yves Saint Laurent" },
  ];

  const womenJewelryWatch = [
    {
      name: "New In Watches",
      params:
        "/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=WFA967se7qX0jYtySgTj",
      nameAr: "",
    },
    {
      name: "New In Jewellery",
      params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=WFA967se7qX0jYtySgTj",
      nameAr: "",
    },
    {
      name: "Bag charms",
      params: "/products?subcategory=pA6VRVYknSalkjfklf",
      nameAr: "",
    },
    {
      name: "Bracelets",
      params: "/products?subcategory=DhlKDrVEqEzryNOmL0n2",
      nameAr: "",
    },
    {
      name: "Earrings",
      params: "/products?subcategory=mtBPHMO5MWBmUvNdCUJF",
      nameAr: "",
    },
    {
      name: "Hair accessories",
      params: "/products?subcategory=WhvbBFPU8ovRs2PD3Afj",
      nameAr: "",
    },
    {
      name: "Jewellery sets",
      params: "/products?subcategory=92V3Z9KOK3bgLgKasr51",
      nameAr: "",
    },
    {
      name: "Necklaces",
      params: "/products?subcategory=3UiCyOIQMzLaWg1pa6E4",
      nameAr: "",
    },
    {
      name: "Pendants",
      params: "/products?subcategory=YGfZxrbhDMH16MzLoObK",
      nameAr: "",
    },
    {
      name: "Pins & brooches",
      params: "/products?subcategory=09NAB58zlxf246G2Zi7h",
      nameAr: "",
    },
    {
      name: "Rings",
      params: "/products?subcategory=YJJJe8JajhHTAk7SCsip",
      nameAr: "",
    },
    {
      name: "All Watches",
      params:
        "/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=WFA967se7qX0jYtySgTj",
      nameAr: "",
    },
    {
      name: "All Jewellery",
      params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=WFA967se7qX0jYtySgTj",
      nameAr: "",
    },
  ];

  const menJewelryWatch = [
    {
      name: "New In Watches",
      params:
        "/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=KG3s4pPk3arcBux5ERnD",
      nameAr: "",
    },
    {
      name: "New In Jewellery",
      // params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=KG3s4pPk3arcBux5ERnD",
      params:
        "/products?subcategory=X219u0BbTXGaT93w3na9&gender=KG3s4pPk3arcBux5ERnD",
      nameAr: "",
    },
    {
      name: "All Watches",
      params:
        "/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=KG3s4pPk3arcBux5ERnD",
      nameAr: "",
    },
    {
      name: "All Jewellery",
      // params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=KG3s4pPk3arcBux5ERnD",
      params:
        "/products?subcategory=X219u0BbTXGaT93w3na9&gender=KG3s4pPk3arcBux5ERnD",
      nameAr: "",
    },
  ];

  // "New In"
  const newIn = [
    {
      name: "Bags & Accessories",
      params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=KG3s4pPk3arcBux5ERnD",
      nameAr: "",
    },
    {
      name: "Baby",
      params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=KG3s4pPk3arcBux5ERnD",
      nameAr: "",
    },
    {
      name: "Boys",
      params:
        "/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=KG3s4pPk3arcBux5ERnD",
      nameAr: "",
    },
    {
      name: "Girls",
      params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=KG3s4pPk3arcBux5ERnD",
      nameAr: "",
    },
    {
      name: "Shoes",
      params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=KG3s4pPk3arcBux5ERnD",
      nameAr: "",
    },
  ];

  // "Clothing for Girls"
  const girlsClothing = [
    {
      name: "Dresses",
      params:
        "/products?subcategory=0ldOyc2LDplxjnFPnpcW&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Jackets & Coats",
      params:
        "/products?subcategory=rWDjOeUiz1s5kCO8xPGh&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Knitwear",
      params:
        "/products?subcategory=RiNT4LdTST5cgdwKlumo&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Outfits",
      params:
        "/products?subcategory=0ldOyc2LDplxjnatowqF&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Pajamas & Bodysuits",
      params:
        "/products?subcategory=0Pp9HzoWrvft8UB5D19k&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Shorts",
      params:
        "/products?subcategory=GtwMidQECoB0Y54kDqOg&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Skirts",
      params:
        "/products?subcategory=TRFN20ugEqoa2YqMCGsc&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Tops",
      params:
        "/products?subcategory=34qlgv58Mh4OFEZBTTui&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Pants",
      params:
        "/products?subcategory=uza8Gy1XbKNcNpi0jfXU&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
  ];
  // Children girl clothes
  const childgirlclothes = [
    {
      name: "Dresses",
      params:
        "/products?subcategory=0ldOyc2LDplxjnFPnpcW&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Jackets & Coats",
      params:
        "/products?subcategory=rWDjOeUiz1s5kCO8xPGh&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Knitwear",
      params:
        "/products?subcategory=RiNT4LdTST5cgdwKlumo&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Girls - Sets",
      params:
        "/products?subcategory=GtwMidaECoB0Y54rDqOg&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Trousers",
      params:
        "/products?subcategory=pA6VRVYknSqqtwfdrtq&id=yJDeEt0uKPxfxtqOM42V&gender=WFA967se7qX0jYtySgTj&",
      nameAr: "",
    },
    {
      name: "Shorts",
      params:
        "/products?subcategory=GtwMidQECoB0Y54kDqOg&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Skirts",
      params:
        "/products?subcategory=TRFN20ugEqoa2YqMCGsc&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
    {
      name: "Tops",
      params:
        "/products?subcategory=34qlgv58Mh4OFEZBTTui&gender=tTwOQNL4etSBiJy0j5zY",
      nameAr: "",
    },
  ];

  // "Clothing for Boys"
  const boysClothing = [
    {
      name: "Jackets & Coats",
      params:
        "/products?subcategory=rWDjOeUiz1s5kCO8xPGh&gender=btauY7skTre33RbhtagD",
      nameAr: "",
    },
    {
      name: "Knitwear",
      params:
        "/products?subcategory=RiNT4LdTST5cgdwKlumo&gender=KG3s4btauY7skTre33RbhtagDpPk3arcBux5ERnD",
      nameAr: "",
    },
    {
      name: "Outfits",
      params:
        "/products?subcategory=0ldOyc2LDplxjnatowqF&gender=btauY7skTre33RbhtagD",
      nameAr: "",
    },
    {
      name: "Shorts",
      params:
        "/products?subcategory=GtwMidQECoB0Y54kDqOg&gender=btauY7skTre33RbhtagD",
      nameAr: "",
    },
    {
      name: "Tops",
      params:
        "/products?subcategory=34qlgv58Mh4OFEZBTTui&gender=btauY7skTre33RbhtagD",
      nameAr: "",
    },
    {
      name: "Pants",
      params:
        "/products?subcategory=uza8Gy1XbKNcNpi0jfXU&gender=btauY7skTre33RbhtagD",
      nameAr: "",
    },
  ];
  // Children boys
  const childboys = [
    {
      name: "Trousers",
      params:
        "/products?subcategory=pA6VRVYknSqqtwfdrtq&id=yJDeEt0uKPxfxtqOM42V&gender=btauY7skTre33RbhtagD&",
      nameAr: "",
    },
    {
      name: "Jackets & Coats",
      params:
        "/products?subcategory=rWDjOeUiz1s5kCO8xPGh&gender=btauY7skTre33RbhtagD&",
      nameAr: "",
    },
    {
      name: "Knitwear",
      params:
        "/products?subcategory=RiNT4LdTST5cgdwKlumo&gender=btauY7skTre33RbhtagD&",
      nameAr: "",
    },
    {
      name: "Boys - Sets",
      params:
        "/products?subcategory=GtwMidaECoB0Y54rDqOg&gender=btauY7skTre33RbhtagD&",
      nameAr: "",
    },
    {
      name: "Shorts",
      params:
        "/products?subcategory=GtwMidQECoB0Y54kDqOg&gender=btauY7skTre33RbhtagD&",
      nameAr: "",
    },
    {
      name: "Tops",
      params:
        "/products?subcategory=34qlgv58Mh4OFEZBTTui&gender=btauY7skTre33RbhtagD&",
      nameAr: "",
    },
  ];
  // "Children's Shoes"
  const childrenShoes = [
    {
      name: "Ballet flats",
      params:
        "/products?subcategory=o5MKsloJPSAFqPBcwrC6&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Boots",
      params:
        "/products?subcategory=Ajx4IbmZyd8tDPIUIWq1&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "First Shoes",
      params:
        "/products?subcategory=o5MKsloJPSAFqr7itcQ&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Flats",
      params:
        "/products?subcategory=o5MKsloJPSAFqsBcwrC6&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Lace up boots",
      params:
        "/products?subcategory=o5MKsloJPSAFqjwywu4&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Sandals",
      params:
        "/products?subcategory=MUMXw3hjGufq8nrZgCi3&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Slippers",
      params:
        "/products?subcategory=o5MKsloJPSAFqPBcwrC4&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    // {
    //   name: "Trainers",
    //   params:
    //     "/products?subcategory=rWDjOeUiz1s5kCO8xPGh&gender=uw8UHRzTK2qlgU8Y4cVc&",
    //   nameAr: "",
    // },
  ];

  // "Bags & Accessories"
  const childrenBagsAcc = [
    {
      name: "Bags & Pencil cases",
      params: "/products?id=LVw0hUP9kEcd1Qr9CoEk&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Belts Susupenders",
      params:
        "/products?subcategory=LVw0hUP9kEcd1Qr9CoEk&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Hats & Gloves",
      params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Jewellery",
      params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Scarves",
      params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
    {
      name: "Sunglasses",
      params: "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=uw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
  ];

  // "Baby"
  const baby = [
    {
      name: "Outfits",
      params:
        "/products?subcategory=0ldOyc2LDplxjnatowqF&gender=zw8UHRzTK2qlgU8Y4cVc",
      nameAr: "",
    },
    {
      name: "Pajamas & Bodysuits",
      params:
        "/products?subcategory=0Pp9HzoWrvft8UB5D19k&gender=zw8UHRzTK2qlgU8Y4cVc",
      nameAr: "",
    },
    {
      name: "Shoes",
      params: "/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=zw8UHRzTK2qlgU8Y4cVc&",
      nameAr: "",
    },
  ];

  const designersSection = [
    {
      name: "Louis Vuitton",
    },
    {
      name: "Gucci",
    },
    {
      name: "Valentino Garavani",
    },
    {
      name: "Chanel",
    },
    {
      name: "Dior",
    },
    {
      name: "Prada",
    },
    {
      name: "Celine",
    },
    {
      name: "Bottega Veneta",
    },
    {
      name: "Saint Laurent",
    },
    {
      name: "Fendi",
    },
    {
      name: "Balenciaga",
    },
    {
      name: "Dolce & Gabanna",
    },
    {
      name: "Michael Kors",
    },
    {
      name: "Marc Jacobs",
    },
    {
      name: "Hermès",
    },
  ];
  const ModelSection = [
    {
      id: "MVj5ICVly4QldEU7TYAU",
      name: "The Birkin",
      nameAr: "بيركين",
    },
    {
      id: "47iinxFNBl51mdw5IDHl",
      name: "The Dionysus",
      nameAr: "ديونيسوس",
    },
    {
      id: "pH8ZCG1ETWR7qPyCEZbq",
      name: "The Jackie 1961",
      nameAr: "جاكي ١٩٦١",
    },
    {
      id: "77VRTOSaGn4SOVuUdFtR",
      name: "The Marmont",
      nameAr: "مارمون",
    },
    {
      id: "ZWtwCjCCf9QAVFyFt8fe",
      name: "The Neverfull",
      nameAr: "نيفيرفل",
    },
    {
      id: "OZ6ZiUTwTOuFbhJxfEPN",
      name: "The LV Pochette Accessoire",
      nameAr: "لويس فيتون بوشيت اكسسوار",
    },
    // {
    //   id: "The Saddle",
    //   brand: "Dior",
    //   name: "The Dior Saddle",
    //   nameAr: "ديور سادل",
    // },
    {
      id: "UaiVnUFP1SFQa1qRISj7",
      name: "The LV Speedy",
      nameAr: "لويس فيتون سبيدي",
    },
    {
      id: "sD0lI9IiRqEhFkYGIwvK",
      name: "The Lady Dior",
      nameAr: "لايدي ديور",
    },
    {
      brand: "Fendi",
      id: "D4sruXCR06IeS7ayMykg",
      name: "The Fendi Baguette",
      nameAr: "فندي باغيت",
    },
    {
      id: "Buxy7ATpMUkQEImE9hsp",
      name: "The Kelly",
      nameAr: "كيلي",
    },
    {
      id: "7eJVq0Qf9ynfJ7I9V0bI",
      name: "The Boy Bag",
      nameAr: "شنطة بوي",
    },

    {
      id: "fPFDIyHOCkF6ECybKbOv",
      name: "The Phantom",
      nameAr: "شنطة بوي",
    },
    {
      id: "qS1mNFjrSrukO9v1joQy",
      name: "The City",
      nameAr: "سيتى",
    },

    {
      id: "3BNZhqSdTwQFeQsd0SDj",
      name: "The Sac Du Jour",
      nameAr: "ساك دو جور",
    },
    {
      id: "5rFS01r1zcy3uo5pSJoC",
      name: "The Triomphe",
      nameAr: "تريومف",
    },
  ];
  const AccWomen = [
    {
      name: "Gloves",
    },
    {
      name: "Hats",
    },
    {
      name: "Purses & cases",
    },
    {
      name: "Scarves",
    },
    {
      name: "Silk handkerchief",
    },
    {
      name: "Sunglasses",
    },

    {
      name: "Belts",
    },
    {
      name: "Bag accessories",
    },
    {
      name: "Wallets",
    },
    // {
    //   name: "Watches",
    // },
  ];
  const bagswomen = [
    { name: "Handbags", nameAr: "حقائب يد" },
    { name: "Crossbody bags", nameAr: "حقائب كروس" },
    { name: "Shoulder bags", nameAr: "حقائب كتف" },
    { name: "Tote bags", nameAr: "حقائب توت" },
    { name: "Clutch bags", nameAr: "حقائب صغيرة" },
    { name: "Travel bags", nameAr: "حقائب سفر" },
    { name: "Backpacks", nameAr: "حقائب ظهر" },
  ];
  const ClothesWomen = [
    {
      name: "Coats",
    },

    {
      name: "Dresses",
    },
    {
      name: "Jackets",
    },
    {
      name: "Jeans",
    },
    {
      name: "Jumpsuits",
    },

    {
      name: "Knitwear",
    },
    {
      name: "Leather jackets",
    },

    {
      name: "Shorts",
    },
    {
      name: "Skirts",
    },
    // {
    //     name:'Sets'
    // },
    {
      name: "Swimwear",
    },

    {
      name: "Tops",
    },
    {
      name: "Trench coats",
    },
    {
      name: "Trousers",
    },
    {
      name: "Lingerie",
    },
  ];
  const ShoesWomen = [
    {
      name: "Sandals",
    },

    {
      name: "Trainers",
    },
    {
      name: "Boots",
    },
    {
      name: "Espadrilles",
    },
    {
      name: "Flat shoes",
    },

    {
      name: "Mules & Clogs",
    },
    {
      name: "Heels",
    },

    {
      name: "Ballet flats",
    },
    {
      name: "Lace ups",
    },

    {
      name: "Ankle boots",
    },
  ];
  const JewelleryWomen = [
    {
      name: "Bracelets",
    },

    {
      name: "Earrings",
    },
    {
      name: "Necklaces",
    },
    {
      name: "Rings",
    },
    {
      name: "Pins & brooches",
    },

    {
      name: "Pendants",
    },
    {
      name: "Bag charms",
    },

    {
      name: "Hair accessories",
      id: "WhvbBFPU8ovRs2PD3Afj",
    },
    {
      name: "Jewellery sets",
    },
  ];
  const ClothesMen = [
    {
      name: "Coats",
    },

    {
      name: "Jackets",
    },
    // {
    //   name: "Leather jackets",
    // },
    {
      name: "Jeans",
    },
    {
      name: "Knitwear & Sweatshirts",
    },
    {
      name: "Polo shirts",
    },
    {
      name: "Shirts",
    },
    {
      name: "Shorts",
    },
    {
      name: "Suits",
    },

    {
      name: "Swimwear",
    },
    {
      name: "T-shirts",
    },
    {
      name: "Trousers",
    },
  ];
  const ShoesMen = [
    {
      name: "Boots",
    },
    {
      name: "Espadrilles",
    },
    {
      name: "Flat shoes",
    },
    {
      name: "Lace-ups",
    },
    {
      name: "Sandals",
    },
    {
      name: "Trainers",
    },
  ];

  const BagsMen = [
    {
      id: "pA6VrVYknSqqte0biIaR",
      name: "Bags",
    },
    {
      id: "tjVkKS7xYRxBJKXdB1hI",
      name: "Backpacks",
    },
    {
      id: "H5kq3freQ5aGasd3JVE1",
      name: "Belt bags",
    },
    {
      id: "bSDphwJfLG35T3uBUCmx",
      name: "Travel bags",
    },
  ];
  const AccMen = [
    {
      name: "Belts",
    },
    {
      name: "Cufflinks",
    },
    {
      name: "Gloves",
    },
    {
      name: "Hats",
    },
    {
      name: "Jewellery",
    },
    {
      name: "Scarves & pocket squares",
    },
    {
      name: "Sunglasses",
    },

    {
      name: "Ties",
    },
    {
      name: "Wallets",
    },
    // {
    //   name: "Watches",
    // },
  ];
  const ShoesDesigners = [
    {
      name: "Christian Louboutin",
    },
    {
      name: "Hermès",
    },
    {
      name: "Saint Laurent",
    },
    {
      name: "Fendi",
    },
    {
      name: "Chanel",
    },
    {
      name: "Gucci",
    },
    {
      name: "Louis Vuitton",
    },
    {
      name: "Dior",
    },
    {
      name: "Miu Miu",
    },
    {
      name: "Prada",
    },

    {
      name: "Celine",
    },
    {
      name: "Bottega Veneta",
    },
    {
      name: "Amina Muaddi",
    },
    {
      name: "Nike",
    },
    {
      name: "Jimmy Choo",
    },
  ];
  const VintageDesigners = [
    {
      name: "Burberry",
      nameAr: "بربري",
    },
    {
      name: "Yves Saint Laurent",
      nameAr: "إيف سان لوران",
    },

    {
      name: "Celine",
      nameAr: "سيلين ",
    },
    {
      name: "Chanel",
      nameAr: "شانيل ",
    },
    {
      name: "Dior",
      nameAr: "ديور ",
    },
    {
      name: "Valentino Garavani",
      nameAr: "فالنتينو جارافاني",
    },
    {
      name: "Fendi",
      nameAr: "فندي ",
    },

    {
      name: "Prada",
      nameAr: "برادا ",
    },

    {
      name: "Hermès",
      nameAr: "هيرميس ",
    },

    {
      name: "Jean-Paul Gaultier",
      nameAr: "جان بول غوتييه",
    },

    {
      name: "Louis Vuitton",
      nameAr: "لويس فويتون",
    },
    {
      name: "Courreges",
      nameAr: "كوريج",
    },
  ];
  const watchesandJewelryMen = [
    {
      name: "Cufflinks",
    },
    // {
    //   name: "Bracelets",
    // },
  ];

  const handleMouseLeave = () => {
    setHoverMenu(false);
  };

  const handleMouseEnter = () => {
    setHoverMenu(true);
  };
  useEffect(() => {
    console.log("activeFilter", activeFilter);
  }, [activeFilter, hide]);

  const ResetFilters = () => {
    dispatch(getAllProductOnline([]));
    dispatch(getLastDoc(null));
    navigate("/products");
    dispatch(SetSelectdPage(0));
    dispatch(SetSizeFilter([]));
    dispatch(SortProducts(""));
    dispatch(SetTopSizeFilter([]));
    dispatch(CheckSoldItems(false));
    dispatch(SetSearch(""));
  };
  return (
    <>
      <div className=" show-modal-download">
        {show && <DownloadModal show={show} setShow={setShow} />}
      </div>
      <header className="header d-lg-flex d-none" style={{ zIndex: "10" }}>
        <nav className="w-100 pt-md-0">
          <hr className="mx-4 pb-2 mt-1" />

          <div
            className="menu-items px-md-4 px-0 mb-3 mt-3 d-flex"
            style={{ justifyContent: "center", position: "relative" }}
          >
            <div className={`menu-items `}>
              <span
                className="menuhover px-0"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                {/* New Arrivals */}
                <Link
                  to="/products?topic=newdrops"
                  className="menu-item  "
                  onClick={() => {
                    // If this filter is already active, return
                    if (activeFilter === "new arrivals") {
                      setHide(true);
                      return;
                    } else {
                      // If activating a new filter, set it as active and reset filters
                      setActiveFilter("new arrivals");
                      dispatch(SortProducts(""));
                      selectedPageNull();
                    }
                  }}
                  onMouseOver={() => setHide(false)}
                >
                  {t("drops")}
                </Link>
                {/* New Arrivals Sub menus */}
                <div
                  // dont close submenu immediately
                  style={{
                    position: "absolute",
                    top: "15px",
                    zIndex: 2,
                    paddingTop: "20px",
                  }}
                  className={`${
                    hide == false ? "mega-menu" : "mega-menu mega-menuCLick"
                  }`}
                  onClick={() => {
                    // If this filter is already active, return
                    if (activeFilter === "new arrivals") {
                      setHide(true);
                      return;
                    } else {
                      // If activating a new filter, set it as active and reset filters
                      setActiveFilter("new arrivals");
                      setHide(true);
                      selectedPageNull();
                    }
                  }}
                >
                  <div className="col-12 p-0 content px-md-4">
                    <div className="pt-3 pb-5 d-flex">
                      <div>
                        <Link
                          to={`/products?topic=newdrops`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "new arrivals") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("new arrivals");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {/* {t("New Arrivals")} */}
                          New In
                        </Link>
                        <div className="subtitlemega pt-3 pb-3">
                          <Link
                            // to="/products?topic=newdrops&id=yJDeEt0uKPxfxtqOM42V&"
                            to="/products?topic=proSeller"
                            className="subtitlemega "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {/* {t("Clothes")} */}
                            We Trust
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&id=AqFLulu9y2m4mqEIkch1"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Bags")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=Vintage"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {/* {t("Shoes")} */}
                            Vintage
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&id=07kdA6cD3NDKxX8pQ7w1"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Jewelry")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&subcategory=kYTvn5wAxopx5jpqotC0&id=LVw0hUP9kEcd1Qr9CoEk"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Watches")}
                          </Link>
                        </div>
                        {/* <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops"
                            className="subtitlemega  "
                            style={{ fontFamily: "Montserrat-M500" }}
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("view-all")}
                          </Link>
                        </div> */}
                      </div>

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to={`/products?topic=newdrops&gender=WFA967se7qX0jYtySgTj`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "new arrivals") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("new arrivals");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {/* {t("Women")} */}
                          Women's
                        </Link>

                        <div className="subtitlemega  pt-3 pb-3">
                          <Link
                            to="/products?topic=newdrops&id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Bags")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&id=yJDeEt0uKPxfxtqOM42V&gender=WFA967se7qX0jYtySgTj&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Clothes")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Shoes")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Accessories")}
                          </Link>
                        </div>

                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&subcategory=kYTvn5wAxopx5jpqotC0&id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Watches")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&id=07kdA6cD3NDKxX8pQ7w1&gender=WFA967se7qX0jYtySgTj&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Jewelry")}
                          </Link>
                        </div>
                        {/* <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&gender=WFA967se7qX0jYtySgTj"
                            style={{ fontFamily: "Montserrat-M500" }}
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("view-all")}
                          </Link>
                        </div> */}
                      </div>

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to={`/products?topic=newdrops&gender=KG3s4pPk3arcBux5ERnD`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "new arrivals") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("new arrivals");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {/* {t("Men")} */}
                          Men's
                        </Link>

                        <div className="subtitlemega  pt-3 pb-3">
                          <Link
                            to="/products?topic=newdrops&id=AqFLulu9y2m4mqEIkch1&gender=KG3s4pPk3arcBux5ERnD"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Bags")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&id=yJDeEt0uKPxfxtqOM42V&gender=KG3s4pPk3arcBux5ERnD&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Clothes")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&id=WJmwaMSWxtl1dK1sPZ1x&gender=KG3s4pPk3arcBux5ERnD&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Shoes")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&id=LVw0hUP9kEcd1Qr9CoEk&gender=KG3s4pPk3arcBux5ERnD&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Accessories")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&subcategory=kYTvn5wAxopx5jpqotC0&id=LVw0hUP9kEcd1Qr9CoEk&gender=KG3s4pPk3arcBux5ERnD&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Watches")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&id=07kdA6cD3NDKxX8pQ7w1&gender=KG3s4pPk3arcBux5ERnD&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Jewelry")}
                          </Link>
                        </div>

                        {/* <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&gender=KG3s4pPk3arcBux5ERnD"
                            style={{ fontFamily: "Montserrat-M500" }}
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("view-all")}
                          </Link>
                        </div> */}
                      </div>

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to={`/products?topic=newdrops&gender=uw8UHRzTK2qlgU8Y4cVc`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "new arrivals") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("new arrivals");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Kids")}
                        </Link>

                        <div className="subtitlemega  pt-3 pb-3">
                          <Link
                            to="/products?topic=newdrops&id=yJDeEt0uKPxfxtqOM42V&gender=btauY7skTre33RbhtagD"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Boys clothes")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&id=yJDeEt0uKPxfxtqOM42V&gender=tTwOQNL4etSBiJy0j5zY&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Girls clothes")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&id=yJDeEt0uKPxfxtqOM42V&gender=zw8UHRzTK2qlgU8Y4cVc&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Baby clothes")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&id=WJmwaMSWxtl1dK1sPZ1x&gender=uw8UHRzTK2qlgU8Y4cVc&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Shoes")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&id=LVw0hUP9kEcd1Qr9CoEk&gender=uw8UHRzTK2qlgU8Y4cVc&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Accessories")}
                          </Link>
                        </div>

                        {/* <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=newdrops&gender=KG3s4pPk3arcBux5ERnD"
                            style={{ fontFamily: "Montserrat-M500" }}
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "new arrivals") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("new arrivals");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("view-all")}
                          </Link>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </span>
            </div>
            {/* designers */}
            <div
              className={`menu-items ${
                i18n.language == "en" ? "ps-4" : `pe-4`
              }`}
            >
              <span
                className="menuhover "
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <Link
                  to="/brands"
                  className="menu-item"
                  onClick={() =>
                    dispatch(SortProducts("")) & selectedPageNull()
                  }
                  onMouseOver={() => setHide(false)}
                >
                  {t("Designers")}
                </Link>
                <div
                  // dont close submenu immediately
                  style={{
                    position: "absolute",
                    top: "15px",
                    zIndex: 2,
                    paddingTop: "20px",
                  }}
                  className={` ${
                    hide == false ? "mega-menu" : ` mega-menu mega-menuCLick`
                  }`}
                  onClick={() => {
                    // If this filter is already active, return
                    if (activeFilter === "designers") {
                      setHide(true);
                      return;
                    } else {
                      // If activating a new filter, set it as active and reset filters
                      setActiveFilter("designers");
                      setHide(true);
                      selectedPageNull();
                    }
                  }}
                >
                  <div className="content px-md-4">
                    <div className="pt-3 pb-5 d-flex">
                      <div>
                        <div className="subtitlemega ">
                          {BrandsSection.map((brandsection) => (
                            <>
                              {brands
                                .filter((brand) => brand.id == brandsection.id)
                                .map((brand) => (
                                  <div className="subtitlemega pb-3">
                                    <Link
                                      to={`/products?brand=${brand.id}&nameBrand=${brand.name}`}
                                      className="subtitlemega "
                                      onClick={() => {
                                        // If this filter is already active, return
                                        if (activeFilter === "designers") {
                                          setHide(true);
                                          return;
                                        } else {
                                          // If activating a new filter, set it as active and reset filters
                                          setActiveFilter("designers");
                                          setHide(true);
                                          selectedPageNull();
                                        }
                                      }}
                                    >
                                      {i18n.language == "en"
                                        ? brand.name
                                        : brand.nameAr}
                                    </Link>
                                  </div>
                                ))}
                            </>
                          ))}
                        </div>
                      </div>

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <div className="subtitlemega ">
                          {BrandsSection2.map((brandsection) => (
                            <>
                              {brands
                                .filter((brand) => brand.id == brandsection.id)
                                .map((brand) => (
                                  <div className="subtitlemega pb-3">
                                    <Link
                                      to={`/products?brand=${brand.id}&nameBrand=${brand.name}`}
                                      className="subtitlemega "
                                      onClick={() => {
                                        // If this filter is already active, return
                                        if (activeFilter === "designers") {
                                          setHide(true);
                                          return;
                                        } else {
                                          // If activating a new filter, set it as active and reset filters
                                          setActiveFilter("designers");
                                          setHide(true);
                                          selectedPageNull();
                                        }
                                      }}
                                    >
                                      {i18n.language == "en"
                                        ? brand.name
                                        : brand.nameAr}
                                    </Link>
                                  </div>
                                ))}
                            </>
                          ))}
                        </div>
                      </div>

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <div className="subtitlemega ">
                          {BrandsSection3.map((brandsection) => (
                            <>
                              {brands
                                .filter((brand) => brand.id == brandsection.id)
                                .map((brand) => (
                                  <div className="subtitlemega pb-3">
                                    <Link
                                      to={`/products?brand=${brand.id}&nameBrand=${brand.name}`}
                                      className="subtitlemega "
                                      onClick={() => {
                                        // If this filter is already active, return
                                        if (activeFilter === "designers") {
                                          setHide(true);
                                          return;
                                        } else {
                                          // If activating a new filter, set it as active and reset filters
                                          setActiveFilter("designers");
                                          setHide(true);
                                          selectedPageNull();
                                        }
                                      }}
                                    >
                                      {i18n.language == "en"
                                        ? brand.name
                                        : brand.nameAr}
                                    </Link>
                                  </div>
                                ))}
                            </>
                          ))}
                          {/* all brands */}
                          <Link
                            to={`/brands`}
                            className="subtitlemega "
                            style={{
                              fontWeight: "600",
                            }}
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "designers") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("designers");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            All Brands
                          </Link>
                        </div>
                        {/* <div
                          className="viewallbrands mt-5"
                          onClick={() => navigate("/Brands")}
                        >
                          {t("View All Brands")}
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </span>
            </div>
            {/* womens main */}
            <div
              className={`menu-items ${
                i18n.language == "en" ? "ps-4" : `pe-4`
              }`}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {/* women submenu */}
              <span className={`menuhover `}>
                <Link
                  to="/products?gender=WFA967se7qX0jYtySgTj"
                  className="menu-item"
                  onClick={() => {
                    // If this filter is already active, return
                    if (activeFilter === "womens") {
                      setHide(true);
                      return;
                    } else {
                      // If activating a new filter, set it as active and reset filters
                      setActiveFilter("womens");
                      dispatch(SortProducts(""));
                      selectedPageNull();
                    }
                  }}
                  onMouseOver={() => setHide(false)}
                >
                  {t("Women")}
                </Link>
                <div
                  // dont close submenu immediately
                  style={{
                    position: "absolute",
                    top: "15px",
                    zIndex: 2,
                    paddingTop: "20px",
                  }}
                  className={` ${
                    hide == false ? "mega-menu" : ` mega-menu mega-menuCLick`
                  }`}
                  onClick={() => {
                    // If this filter is already active, return
                    if (activeFilter === "womens") {
                      setHide(true);
                      return;
                    } else {
                      // If activating a new filter, set it as active and reset filters
                      setActiveFilter("womens");
                      setHide(true);
                      selectedPageNull();
                    }
                  }}
                >
                  <div className="content px-md-4">
                    <div className="pt-3 pb-5 d-flex">
                      <div>
                        <Link
                          to={`/products?id=yJDeEt0uKPxfxtqOM42V&gender=WFA967se7qX0jYtySgTj`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "womens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("womens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Clothes")}
                        </Link>
                        <div className="subtitlemega pt-4 pb-4">
                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=yJDeEt0uKPxfxtqOM42V&gender=WFA967se7qX0jYtySgTj`}
                              className="subtitlemega "
                              onClick={() =>
                                setHide(true) &
                                selectedPageNull() &
                                dispatch(SortProducts("Newest"))
                              }
                            >
                              {t("Just in")}
                            </Link>
                          </div> */}

                          {ClothesWomen.map((cloth) =>
                            SubCategory.filter(
                              (subcat) => subcat.name == cloth.name
                            )
                              .sort((a, b) => (a.name > b.name ? 1 : -1))
                              .map((sub) => (
                                <>
                                  <div
                                    className="subtitlemega pb-3"
                                    onClick={() => {
                                      // If this filter is already active, return
                                      if (activeFilter === "womens") {
                                        setHide(true);
                                        return;
                                      } else {
                                        // If activating a new filter, set it as active
                                        setActiveFilter("womens");
                                        setHide(true);
                                        selectedPageNull();
                                      }
                                    }}
                                  >
                                    <Link
                                      to={`/products?id=yJDeEt0uKPxfxtqOM42V&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`}
                                      className="subtitlemega "
                                    >
                                      {i18n.language == "en"
                                        ? sub.name
                                        : sub.nameAr}
                                    </Link>
                                  </div>
                                </>
                              ))
                          )}
                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=yJDeEt0uKPxfxtqOM42V&gender=WFA967se7qX0jYtySgTj`}
                              style={{ fontFamily: "Montserrat-M500" }}
                              className="subtitlemega "
                              onClick={() => {
                                // If this filter is already active, return
                                if (activeFilter === "womens") {
                                  setHide(true);
                                  return;
                                } else {
                                  // If activating a new filter, set it as active and reset filters
                                  setActiveFilter("womens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              {t("View All Clothes")}
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                      >
                        <Link
                          to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "womens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("womens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Shoes")}
                        </Link>
                        <div className="subtitlemega pt-4 pb-4">
                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj`}
                              className="subtitlemega "
                              onClick={() =>
                                setHide(true) &
                                selectedPageNull() &
                                dispatch(SortProducts("Newest"))
                              }
                            >
                              {t("Just in")}
                            </Link>
                          </div> */}

                          {SubCategory?.filter(
                            (subcat) =>
                              subcat.idTypeCategory ===
                                "WJmwaMSWxtl1dK1sPZ1x" &&
                              ShoesWomen.some(
                                (shoe) => shoe.name === subcat.name
                              )
                          )
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((sub) => (
                              <div
                                className="subtitlemega pb-3"
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "womens") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("womens");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <Link
                                  to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`}
                                  className="subtitlemega"
                                >
                                  {i18n.language === "en"
                                    ? sub.name
                                    : sub.nameAr}
                                </Link>
                              </div>
                            ))}

                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj`}
                              style={{ fontFamily: "Montserrat-M500" }}
                              className="subtitlemega "
                              onClick={() => {
                                // If this filter is already active, return
                                if (activeFilter === "womens") {
                                  setHide(true);
                                  return;
                                } else {
                                  // If activating a new filter, set it as active and reset filters
                                  setActiveFilter("womens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              {t("View All Shoes")}
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to={`/products?id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "womens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("womens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Bags")}
                        </Link>
                        <div
                          className="subtitlemega pt-4 pb-4"
                          // dir={isArabic ? "rtl" : "ltr"}
                        >
                          {/* Subcategory Filtering */}
                          {SubCategory.filter(
                            (subcat) =>
                              subcat.idTypeCategory ===
                                "AqFLulu9y2m4mqEIkch1" &&
                              bagswomen.some((bag) => bag.name === subcat.name)
                          )
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((sub) => (
                              <div
                                key={sub.id}
                                className="subtitlemega pb-3"
                                onClick={() => {
                                  if (activeFilter === "womens") {
                                    setHide(true);
                                    return;
                                  } else {
                                    setActiveFilter("womens");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <Link
                                  to={`/products?id=AqFLulu9y2m4mqEIkch1&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`}
                                  className="subtitlemega"
                                >
                                  {i18n.language !== "en"
                                    ? sub.nameAr || sub.name
                                    : sub.name}
                                </Link>
                              </div>
                            ))}

                          {/* "View All Bags" Link */}
                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj`}
                              style={{ fontFamily: "Montserrat-M500" }}
                              className="subtitlemega"
                              onClick={() => {
                                if (activeFilter === "womens") {
                                  setHide(true);
                                  return;
                                } else {
                                  setActiveFilter("womens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              {t("View All Bags")}
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to={`/products?id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "womens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("womens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Accessories")}
                        </Link>
                        <div className="subtitlemega pt-4 pb-4">
                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj`}
                              className="subtitlemega "
                              onClick={() =>
                                setHide(true) &
                                selectedPageNull() &
                                dispatch(SortProducts("Newest"))
                              }
                            >
                              {t("Just in")}
                            </Link>
                          </div> */}
                          {AccWomen?.map((acc) =>
                            SubCategory.filter(
                              (subcat) =>
                                subcat.name == acc.name &&
                                subcat.idTypeCategory == "LVw0hUP9kEcd1Qr9CoEk"
                            )?.map((sub) => (
                              <>
                                <div
                                  className="subtitlemega pb-3"
                                  onClick={() => {
                                    // If this filter is already active, return
                                    if (activeFilter === "womens") {
                                      setHide(true);
                                      return;
                                    } else {
                                      // If activating a new filter, set it as active and reset filters
                                      setActiveFilter("womens");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <Link
                                    to={`/products?id=LVw0hUP9kEcd1Qr9CoEk&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`}
                                    className="subtitlemega "
                                  >
                                    {i18n.language == "en"
                                      ? sub.name
                                      : sub.nameAr}
                                  </Link>
                                </div>
                              </>
                            ))
                          )}

                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj`}
                              style={{ fontFamily: "Montserrat-M500" }}
                              className="subtitlemega "
                              onClick={() => {
                                // If this filter is already active, return
                                if (activeFilter === "womens") {
                                  setHide(true);
                                  return;
                                } else {
                                  // If activating a new filter, set it as active and reset filters
                                  setActiveFilter("womens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              {t("View All Accessories")}
                            </Link>
                          </div> */}
                        </div>
                      </div>
                      {/* women jewlery */}
                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to={`/products?id=07kdA6cD3NDKxX8pQ7w1&gender=WFA967se7qX0jYtySgTj&`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "womens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("womens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("watchesandJewelry")}
                        </Link>
                        <div className="subtitlemega pt-4 pb-4">
                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=07kdA6cD3NDKxX8pQ7w1&gender=WFA967se7qX0jYtySgTj`}
                              className="subtitlemega "
                              onClick={() =>
                                setHide(true) &
                                selectedPageNull() &
                                dispatch(SortProducts("Newest"))
                              }
                            >
                              {t("Just in")}
                            </Link>
                          </div> */}
                          {SubCategory.filter(
                            (subcat) =>
                              subcat.idTypeCategory ===
                                "07kdA6cD3NDKxX8pQ7w1" &&
                              subcat.id !== "8aLDyffgJkHZdmFkFwRc" &&
                              JewelleryWomen.some(
                                (jewel) => jewel.name === subcat.name
                              )
                          )
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((sub) => {
                              // Check if this is a hair accessories item
                              const isHairAccessories =
                                sub.name === "Hair accessories";
                              console.log(
                                isHairAccessories,
                                "isHairAccessories"
                              );
                              console.log(sub, "sub");

                              // For hair accessories, use the specific ID from the other entry
                              // and a simplified URL structure as requested
                              const linkUrl = isHairAccessories
                                ? `/products?subcategory=WhvbBFPU8ovRs2PD3Afj`
                                : `/products?id=${sub.idTypeCategory}&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`;

                              return (
                                <div
                                  className="subtitlemega pb-3"
                                  key={sub.id}
                                  onClick={() => {
                                    if (activeFilter === "womens") {
                                      setHide(true);
                                      return;
                                    } else {
                                      setActiveFilter("womens");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <Link to={linkUrl} className="subtitlemega">
                                    {i18n.language === "en"
                                      ? sub.name
                                      : sub.nameAr}
                                  </Link>
                                </div>
                              );
                            })}
                          {/* womens watches */}
                          {SubCategory.filter(
                            (subcat) => subcat.id === "kYTvn5wAxopx5jpqotC0"
                          )
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((sub) => (
                              <div
                                className="subtitlemega pb-3"
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "womens") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("womens");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <Link
                                  to={`/products?subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`}
                                  className="subtitlemega"
                                >
                                  {i18n.language === "en"
                                    ? sub.name
                                    : sub.nameAr}
                                </Link>
                              </div>
                            ))}

                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=07kdA6cD3NDKxX8pQ7w1&gender=WFA967se7qX0jYtySgTj&`}
                              style={{ fontFamily: "Montserrat-M500" }}
                              className="subtitlemega "
                              onClick={() => {
                                // If this filter is already active, return
                                if (activeFilter === "womens") {
                                  setHide(true);
                                  return;
                                } else {
                                  // If activating a new filter, set it as active and reset filters
                                  setActiveFilter("womens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              {t("View All Jewelry")}
                            </Link>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
            </div>
            {/* mens main*/}
            <div
              className={`menu-items ${
                i18n.language == "en" ? "ps-4" : `pe-4`
              }`}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <span className={`menuhover `}>
                <Link
                  to="/products?gender=KG3s4pPk3arcBux5ERnD"
                  className="menu-item"
                  onClick={() => {
                    // If this filter is already active, return
                    if (activeFilter === "mens") {
                      setHide(true);
                      return;
                    } else {
                      // If activating a new filter, set it as active and reset filters
                      setActiveFilter("mens");
                      dispatch(SortProducts(""));
                      selectedPageNull();
                    }
                  }}
                  onMouseOver={() => setHide(false)}
                >
                  {t("Men")}
                </Link>
                <div
                  // dont close submenu immediately
                  style={{
                    position: "absolute",
                    top: "15px",
                    zIndex: 2,
                    paddingTop: "20px",
                  }}
                  className={` ${
                    hide == false ? "mega-menu" : ` mega-menu mega-menuCLick`
                  }`}
                  onClick={() => {
                    // If this filter is already active, return
                    if (activeFilter === "mens") {
                      setHide(true);
                      return;
                    } else {
                      // If activating a new filter, set it as active and reset filters
                      setActiveFilter("mens");
                      setHide(true);
                      selectedPageNull();
                    }
                  }}
                >
                  <div className="content px-md-4">
                    <div className="pt-3 pb-5 d-flex">
                      <div>
                        <Link
                          to={`/products?id=yJDeEt0uKPxfxtqOM42V&gender=KG3s4pPk3arcBux5ERnD`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "mens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("mens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Clothes")}
                        </Link>
                        <div className="subtitlemega pt-4 pb-4">
                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=yJDeEt0uKPxfxtqOM42V&gender=KG3s4pPk3arcBux5ERnD`}
                              className="subtitlemega "
                              onClick={() =>
                                setHide(true) &
                                selectedPageNull() &
                                dispatch(SortProducts("Newest"))
                              }
                            >
                              {t("Just in")}
                            </Link>
                          </div> */}
                          {ClothesMen.map((clothemen) =>
                            SubCategory.filter(
                              (subcat) => subcat.name == clothemen.name
                            )
                              .sort((a, b) => (a.name > b.name ? 1 : -1))
                              .map((sub) => (
                                <>
                                  <div
                                    className="subtitlemega pb-3"
                                    onClick={() => {
                                      // If this filter is already active, return
                                      if (activeFilter === "mens") {
                                        setHide(true);
                                        return;
                                      } else {
                                        // If activating a new filter, set it as active and reset filters
                                        setActiveFilter("mens");
                                        setHide(true);
                                        selectedPageNull();
                                      }
                                    }}
                                  >
                                    <Link
                                      to={`/products?id=yJDeEt0uKPxfxtqOM42V&subcategory=${sub.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                      className="subtitlemega "
                                    >
                                      {i18n.language == "en"
                                        ? sub.name
                                        : sub.nameAr}
                                    </Link>
                                  </div>
                                </>
                              ))
                          )}

                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=yJDeEt0uKPxfxtqOM42V&gender=KG3s4pPk3arcBux5ERnD`}
                              style={{ fontFamily: "Montserrat-M500" }}
                              className="subtitlemega "
                              onClick={() => {
                                // If this filter is already active, return
                                if (activeFilter === "mens") {
                                  setHide(true);
                                  return;
                                } else {
                                  // If activating a new filter, set it as active and reset filters
                                  setActiveFilter("mens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              {t("View All Clothes")}
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=KG3s4pPk3arcBux5ERnD`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "mens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("mens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Shoes")}
                        </Link>
                        <div className="subtitlemega pt-4 pb-4">
                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=KG3s4pPk3arcBux5ERnD`}
                              className="subtitlemega "
                              onClick={() =>
                                setHide(true) &
                                selectedPageNull() &
                                dispatch(SortProducts("Newest"))
                              }
                            >
                              {t("Just in")}
                            </Link>
                          </div> */}
                          {ShoesMen.map((shoes) =>
                            SubCategory.filter(
                              (subcat) => subcat.name == shoes.name
                            ).map((sub) => (
                              <>
                                <div
                                  className="subtitlemega pb-3"
                                  onClick={() => {
                                    // If this filter is already active, return
                                    if (activeFilter === "mens") {
                                      setHide(true);
                                      return;
                                    } else {
                                      // If activating a new filter, set it as active and reset filters
                                      setActiveFilter("mens");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <Link
                                    to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&subcategory=${sub.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                    className="subtitlemega "
                                  >
                                    {i18n.language == "en"
                                      ? sub.name
                                      : sub.nameAr}
                                  </Link>
                                </div>
                              </>
                            ))
                          )}

                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=KG3s4pPk3arcBux5ERnD`}
                              style={{ fontFamily: "Montserrat-M500" }}
                              className="subtitlemega "
                              onClick={() => {
                                // If this filter is already active, return
                                if (activeFilter === "mens") {
                                  setHide(true);
                                  return;
                                } else {
                                  // If activating a new filter, set it as active and reset filters
                                  setActiveFilter("mens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              {t("View All Shoes")}
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to={`/products?id=AqFLulu9y2m4mqEIkch1&gender=KG3s4pPk3arcBux5ERnD`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "mens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("mens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Bags")}
                        </Link>

                        <div className="subtitlemega pt-4 pb-4">
                          {BagsMen?.map((bags) =>
                            SubCategory.filter(
                              (subcat) =>
                                subcat.name == bags.name &&
                                subcat.idTypeCategory === "AqFLulu9y2m4mqEIkch1"
                            ).map((sub) => (
                              <>
                                <div
                                  className="subtitlemega pb-3"
                                  onClick={() => {
                                    // If this filter is already active, return
                                    if (activeFilter === "mens") {
                                      setHide(true);
                                      return;
                                    } else {
                                      // If activating a new filter, set it as active and reset filters
                                      setActiveFilter("mens");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <Link
                                    to={`/products?id=AqFLulu9y2m4mqEIkch1&subcategory=${bags?.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                    className="subtitlemega "
                                  >
                                    {i18n.language == "en"
                                      ? sub.name
                                      : sub.nameAr}
                                  </Link>
                                </div>
                              </>
                            ))
                          )}

                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=AqFLulu9y2m4mqEIkch1&gender=KG3s4pPk3arcBux5ERnD`}
                              style={{ fontFamily: "Montserrat-M500" }}
                              className="subtitlemega "
                              onClick={() => {
                                // If this filter is already active, return
                                if (activeFilter === "mens") {
                                  setHide(true);
                                  return;
                                } else {
                                  // If activating a new filter, set it as active and reset filters
                                  setActiveFilter("mens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              {t("View All Bags")}
                            </Link>
                          </div> */}
                        </div>
                      </div>
                      {/* men accessories */}
                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to={`/products?id=LVw0hUP9kEcd1Qr9CoEk&gender=KG3s4pPk3arcBux5ERnD`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "mens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("mens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Accessories")}
                        </Link>
                        <div className="subtitlemega pt-4 pb-4">
                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=LVw0hUP9kEcd1Qr9CoEk&gender=KG3s4pPk3arcBux5ERnD`}
                              className="subtitlemega "
                              onClick={() =>
                                setHide(true) &
                                selectedPageNull() &
                                dispatch(SortProducts("Newest"))
                              }
                            >
                              {t("Just in")}
                            </Link>
                          </div> */}
                          {AccMen.map((acc) =>
                            acc.name === "Jewellery" ? (
                              <div
                                className="subtitlemega pb-3"
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "mens") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("mens");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <Link
                                  to={`/products?id=07kdA6cD3NDKxX8pQ7w1&gender=KG3s4pPk3arcBux5ERnD`}
                                  className="subtitlemega"
                                >
                                  {i18n.language === "en"
                                    ? acc.name
                                    : acc.nameAr}
                                </Link>
                              </div>
                            ) : (
                              SubCategory.filter(
                                (subcat) =>
                                  subcat.name === acc.name &&
                                  subcat.idTypeCategory ===
                                    "LVw0hUP9kEcd1Qr9CoEk"
                              ).map((sub) => (
                                <div
                                  className="subtitlemega pb-3"
                                  onClick={() => {
                                    // If this filter is already active, return
                                    if (activeFilter === "mens") {
                                      setHide(true);
                                      return;
                                    } else {
                                      // If activating a new filter, set it as active and reset filters
                                      setActiveFilter("mens");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <Link
                                    to={`/products?id=LVw0hUP9kEcd1Qr9CoEk&subcategory=${sub.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                    className="subtitlemega"
                                  >
                                    {i18n.language === "en"
                                      ? sub.name
                                      : sub.nameAr}
                                  </Link>
                                </div>
                              ))
                            )
                          )}

                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=LVw0hUP9kEcd1Qr9CoEk&gender=KG3s4pPk3arcBux5ERnD`}
                              style={{ fontFamily: "Montserrat-M500" }}
                              className="subtitlemega "
                              onClick={() => {
                                // If this filter is already active, return
                                if (activeFilter === "mens") {
                                  setHide(true);
                                  return;
                                } else {
                                  // If activating a new filter, set it as active and reset filters
                                  setActiveFilter("mens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              {t("View All Accessories")}
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to={`/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=KG3s4pPk3arcBux5ERnD`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "mens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("mens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("watchesandJewelry")}
                        </Link>
                        <div className="subtitlemega pt-4 pb-4">
                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=07kdA6cD3NDKxX8pQ7w1&gender=KG3s4pPk3arcBux5ERnD`}
                              className="subtitlemega "
                              onClick={() =>
                                setHide(true) &
                                selectedPageNull() &
                                dispatch(SortProducts("Newest"))
                              }
                            >
                              {t("Just in")}
                            </Link>
                          </div> */}
                          {watchesandJewelryMen.map((watchess) =>
                            SubCategory.filter(
                              (subcat) =>
                                subcat.name == watchess.name &&
                                subcat.idTypeCategory == "07kdA6cD3NDKxX8pQ7w1"
                            )
                              .sort((a, b) => (a.name > b.name ? 1 : -1))
                              .map((sub, ind) => (
                                <div key={ind}>
                                  <div
                                    className="subtitlemega pb-3"
                                    onClick={() => {
                                      // If this filter is already active, return
                                      if (activeFilter === "mens") {
                                        setHide(true);
                                        return;
                                      } else {
                                        // If activating a new filter, set it as active and reset filters
                                        setActiveFilter("mens");
                                        setHide(true);
                                        selectedPageNull();
                                      }
                                    }}
                                  >
                                    <Link
                                      to={`/products?id=${sub.idTypeCategory}&subcategory=${sub.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                      className="subtitlemega "
                                    >
                                      {i18n.language == "en"
                                        ? sub.name
                                        : sub.nameAr}
                                    </Link>
                                  </div>
                                </div>
                              ))
                          )}

                          {SubCategory.filter(
                            (subcat) => subcat.id == "kYTvn5wAxopx5jpqotC0"
                          )
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((sub) => (
                              <>
                                <div
                                  className="subtitlemega pb-3"
                                  onClick={() => {
                                    // If this filter is already active, return
                                    if (activeFilter === "mens") {
                                      setHide(true);
                                      return;
                                    } else {
                                      // If activating a new filter, set it as active and reset filters
                                      setActiveFilter("mens");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <Link
                                    to={`/products?subcategory=${sub.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                    className="subtitlemega "
                                  >
                                    {i18n.language == "en"
                                      ? sub.name
                                      : sub.nameAr}
                                  </Link>
                                </div>
                              </>
                            ))}
                          {/* mens jewellery */}
                          {SubCategory.filter(
                            (subcat) => subcat.id == "X219u0BbTXGaT93w3na9"
                          )
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((sub, ind) => (
                              <div key={ind}>
                                <div
                                  className="subtitlemega pb-3"
                                  onClick={() => {
                                    // If this filter is already active, return
                                    if (activeFilter === "mens") {
                                      setHide(true);
                                      return;
                                    } else {
                                      // If activating a new filter, set it as active and reset filters
                                      setActiveFilter("mens");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <Link
                                    to={`/products?subcategory=${sub.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                    className="subtitlemega "
                                  >
                                    {i18n.language == "en"
                                      ? sub.name
                                      : sub.nameAr}
                                  </Link>
                                </div>
                              </div>
                            ))}
                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=KG3s4pPk3arcBux5ERnD`}
                              style={{ fontFamily: "Montserrat-M500" }}
                              className="subtitlemega "
                              onClick={() => {
                                // If this filter is already active, return
                                if (activeFilter === "mens") {
                                  setHide(true);
                                  return;
                                } else {
                                  // If activating a new filter, set it as active and reset filters
                                  setActiveFilter("mens");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              {t("View All Jewelry")}
                            </Link>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
            </div>
            {/* vintage main */}
            <div
              className={`menu-items ${
                i18n.language == "en" ? "ps-4" : `pe-4`
              }`}
            >
              <span
                className="menuhover px-0"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <Link
                  to="/products?topic=Vintage"
                  className="menu-item"
                  onClick={() => {
                    // If this filter is already active, return
                    if (activeFilter === "vintage") {
                      setHide(true);
                      return;
                    } else {
                      // If activating a new filter, set it as active and reset filters
                      setActiveFilter("vintage");
                      dispatch(SortProducts(""));
                      selectedPageNull();
                    }
                  }}
                  onMouseOver={() => setHide(false)}
                >
                  {t("vintage")}
                </Link>
                <div
                  // dont close submenu immediately
                  style={{
                    position: "absolute",
                    top: "15px",
                    zIndex: 2,
                    paddingTop: "20px",
                  }}
                  className={` ${
                    hide == false ? "mega-menu" : ` mega-menu mega-menuCLick`
                  }`}
                  onClick={() => {
                    // If this filter is already active, return
                    if (activeFilter === "vintage") {
                      setHide(true);
                      return;
                    } else {
                      // If activating a new filter, set it as active and reset filters
                      setActiveFilter("vintage");
                      setHide(true);
                      selectedPageNull();
                    }
                  }}
                >
                  <div className="content px-md-4">
                    <div className="pt-3 pb-5 d-flex">
                      <div>
                        <Link
                          to="/products?topic=Vintage&"
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "vintage") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("vintage");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Designers")}
                        </Link>

                        <div className="subtitlemega pt-4">
                          {VintageDesigners.map((brand) => (
                            <>
                              <div className="subtitlemega pb-3">
                                <Link
                                  to={`/products?topic=Vintage&nameBrand=${brand.name}`}
                                  className="subtitlemega "
                                  onClick={() => {
                                    // If this filter is already active, return
                                    if (activeFilter === "vintage") {
                                      setHide(true);
                                      return;
                                    } else {
                                      // If activating a new filter, set it as active and reset filters
                                      setActiveFilter("vintage");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  {i18n.language == "en"
                                    ? brand.name
                                    : brand.nameAr}
                                </Link>
                              </div>
                            </>
                          ))}
                        </div>
                        {/* <div className="subtitlemega pb-3">
                          <Link
                            to={`/products?topic=Vintage`}
                            className="subtitlemega "
                            style={{ fontFamily: "Montserrat-M500" }}
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "vintage") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("vintage");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("View All Vintage")}
                          </Link>
                        </div> */}
                      </div>

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to="/products?topic=Vintage&gender=WFA967se7qX0jYtySgTj&"
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "vintage") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("vintage");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {/* {t("Women")} */}
                          Women's
                        </Link>
                        <div className="subtitlemega  pt-3 pb-3">
                          <Link
                            to="/products?topic=Vintage&id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "vintage") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("vintage");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Bags")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=Vintage&id=yJDeEt0uKPxfxtqOM42V&gender=WFA967se7qX0jYtySgTj&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "vintage") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("vintage");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Clothes")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=Vintage&id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "vintage") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("vintage");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Shoes")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=Vintage&id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "vintage") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("vintage");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Accessories")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=Vintage&id=07kdA6cD3NDKxX8pQ7w1&gender=WFA967se7qX0jYtySgTj&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "vintage") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("vintage");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Jewelry")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=Vintage&subcategory=kYTvn5wAxopx5jpqotC0&id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "vintage") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("vintage");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Watches")}
                          </Link>
                        </div>
                        {/* <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=Vintage&gender=WFA967se7qX0jYtySgTj"
                            style={{ fontFamily: "Montserrat-M500" }}
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "vintage") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("vintage");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("view-all")}
                          </Link>
                        </div> */}
                      </div>

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to="/products?topic=Vintage&gender=KG3s4pPk3arcBux5ERnD&"
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "vintage") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("vintage");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {/* {t("Men")} */}
                          Men's
                        </Link>
                        <div className="subtitlemega  pt-3 pb-3">
                          <Link
                            to="/products?topic=Vintage&id=AqFLulu9y2m4mqEIkch1&gender=KG3s4pPk3arcBux5ERnD"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "vintage") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("vintage");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Bags")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=Vintage&id=yJDeEt0uKPxfxtqOM42V&gender=KG3s4pPk3arcBux5ERnD&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "vintage") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("vintage");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Clothes")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=Vintage&id=WJmwaMSWxtl1dK1sPZ1x&gender=KG3s4pPk3arcBux5ERnD&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "vintage") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("vintage");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Shoes")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=Vintage&id=LVw0hUP9kEcd1Qr9CoEk&gender=KG3s4pPk3arcBux5ERnD&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "vintage") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("vintage");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Accessories")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=Vintage&id=07kdA6cD3NDKxX8pQ7w1&gender=KG3s4pPk3arcBux5ERnD&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "vintage") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("vintage");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Jewelry")}
                          </Link>
                        </div>
                        <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=Vintage&subcategory=kYTvn5wAxopx5jpqotC0&id=LVw0hUP9kEcd1Qr9CoEk&gender=KG3s4pPk3arcBux5ERnD&"
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "vintage") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("vintage");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("Watches")}
                          </Link>
                        </div>
                        {/* <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?topic=Vintage&gender=KG3s4pPk3arcBux5ERnD"
                            style={{ fontFamily: "Montserrat-M500" }}
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "vintage") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("vintage");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("view-all")}
                          </Link>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </span>
            </div>
            {/* bags main */}
            <div
              className={`menu-items ${
                i18n.language == "en" ? "ps-4" : `pe-4`
              }`}
            >
              <span
                className="menuhover px-0  "
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <Link
                  to="/products?id=AqFLulu9y2m4mqEIkch1"
                  className="menu-item"
                  onClick={() => {
                    // If this filter is already active, return
                    if (activeFilter === "bags") {
                      setHide(true);
                      return;
                    } else {
                      // If activating a new filter, set it as active and reset filters
                      setActiveFilter("bags");
                      dispatch(SortProducts(""));
                      selectedPageNull();
                    }
                  }}
                  onMouseOver={() => setHide(false)}
                >
                  {t("Bags")}
                </Link>
                <div
                  // dont close submenu immediately
                  style={{
                    position: "absolute",
                    top: "15px",
                    zIndex: 2,
                    paddingTop: "20px",
                  }}
                  className={` ${
                    hide == false ? "mega-menu" : ` mega-menu mega-menuCLick`
                  }`}
                  onClick={() => {
                    // If this filter is already active, return
                    if (activeFilter === "bags") {
                      setHide(true);
                      return;
                    } else {
                      // If activating a new filter, set it as active and reset filters
                      setActiveFilter("bags");
                      setHide(true);
                      selectedPageNull();
                    }
                  }}
                >
                  <div className="content px-md-4">
                    <div className="pt-3 pb-5 d-flex">
                      <div>
                        <Link
                          to={`/products?id=AqFLulu9y2m4mqEIkch1&`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "bags") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("bags");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Designers")}
                        </Link>

                        <div className="subtitlemega pt-4">
                          {designersSection.map((brandsection) => (
                            <>
                              {brands
                                .filter(
                                  (brand) => brand.name == brandsection.name
                                )
                                .map((brand) => (
                                  <div className="subtitlemega pb-3">
                                    <Link
                                      to={`/products?id=AqFLulu9y2m4mqEIkch1&brand=${brand.id}`}
                                      className="subtitlemega "
                                      onClick={() => {
                                        // If this filter is already active, return
                                        if (activeFilter === "bags") {
                                          setHide(true);
                                          return;
                                        } else {
                                          // If activating a new filter, set it as active and reset filters
                                          setActiveFilter("bags");
                                          setHide(true);
                                          selectedPageNull();
                                        }
                                      }}
                                    >
                                      {i18n.language == "en"
                                        ? brand.name
                                        : brand.nameAr}
                                    </Link>
                                  </div>
                                ))}
                            </>
                          ))}
                        </div>
                        {/* <div className="subtitlemega pb-3">
                          <Link
                            to={`/brands`}
                            className="subtitlemega "
                            style={{ fontFamily: "Montserrat-M500" }}
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "bags") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("bags");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("View All Brands")}
                          </Link>
                        </div> */}
                      </div>

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega `
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to={`/products?id=AqFLulu9y2m4mqEIkch1`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "bags") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("bags");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Timeless Models")}
                        </Link>

                        <div className="subtitlemega pt-4">
                          {ModelSection?.map((model) => (
                            <>
                              <div className="subtitlemega pb-3">
                                <Link
                                  to={`/products?model=${model.id}`}
                                  className="subtitlemega "
                                  onClick={() => {
                                    // If this filter is already active, return
                                    if (activeFilter === "bags") {
                                      setHide(true);
                                      return;
                                    } else {
                                      // If activating a new filter, set it as active and reset filters
                                      setActiveFilter("bags");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  {i18n.language == "en"
                                    ? model.name
                                    : model.nameAr}
                                </Link>
                              </div>
                            </>
                          ))}
                        </div>
                      </div>

                      {/* <div className={`  ${i18n.language=="en"?`padding-sectionmega`:`padding-sectionmegaAr`}`}>
           
        
       
           
            <div className="subtitlemega pt-5">
                <div className="pt-2">
                {ModelSection2.map((model)=>
                <>
                
                    <div  className="subtitlemega pb-3 ">
                    <Link to={`/products?model=${model.name.toLowerCase()}`}  className="subtitlemega " onClick={()=>setHide(true)&selectedPageNull()}>
                    {model.name}
                    </Link>
                    </div>
             
                </>
                )
                
                
            }
           </div>
            </div>
            </div> */}

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to={`/products?id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "bags") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("bags");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {/* {t("Women")} */}Women's
                        </Link>
                        <div className="pt-4">
                          {SubCategory.filter(
                            (subcat) =>
                              subcat.idTypeCategory ===
                                "AqFLulu9y2m4mqEIkch1" &&
                              bagswomen?.some((bag) => bag.name === subcat.name) // Check if name exists in bagswomen
                          )
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((sub) => (
                              <>
                                <div
                                  className="subtitlemega pb-3"
                                  onClick={() => {
                                    // If this filter is already active, return
                                    if (activeFilter === "bags") {
                                      setHide(true);
                                      return;
                                    } else {
                                      // If activating a new filter, set it as active and reset filters
                                      setActiveFilter("bags");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <Link
                                    to={`/products?id=AqFLulu9y2m4mqEIkch1&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`}
                                    className="subtitlemega "
                                  >
                                    {i18n.language == "en"
                                      ? sub.name
                                      : sub.nameAr}
                                  </Link>
                                </div>
                              </>
                            ))}
                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj&`}
                              style={{ fontFamily: "Montserrat-M500" }}
                              className="subtitlemega "
                              onClick={() => {
                                // If this filter is already active, return
                                if (activeFilter === "bags") {
                                  setHide(true);
                                  return;
                                } else {
                                  // If activating a new filter, set it as active and reset filters
                                  setActiveFilter("bags");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              {t("View All Women Bags")}
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to={`/products?id=AqFLulu9y2m4mqEIkch1&gender=KG3s4pPk3arcBux5ERnD`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "bags") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("bags");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {/* {t("Men")} */}
                          Men's
                        </Link>
                        <div className="pt-4">
                          {BagsMen?.map((bags) =>
                            SubCategory.filter(
                              (subcat) =>
                                subcat.name === bags.name &&
                                subcat.idTypeCategory === "AqFLulu9y2m4mqEIkch1"
                            ).map((sub) => (
                              <div
                                key={sub.id} // Add key to avoid React warnings
                                className="subtitlemega pb-3"
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "bags") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("bags");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <Link
                                  to={`/products?id=AqFLulu9y2m4mqEIkch1&subcategory=${sub.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                  className="subtitlemega"
                                >
                                  {i18n.language === "en"
                                    ? sub.name
                                    : sub.nameAr}
                                </Link>
                              </div>
                            ))
                          )}
                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=AqFLulu9y2m4mqEIkch1&gender=KG3s4pPk3arcBux5ERnD`}
                              style={{ fontFamily: "Montserrat-M500" }}
                              className="subtitlemega"
                              onClick={() => {
                                // If this filter is already active, return
                                if (activeFilter === "bags") {
                                  setHide(true);
                                  return;
                                } else {
                                  // If activating a new filter, set it as active and reset filters
                                  setActiveFilter("bags");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              {t("View All Men Bags")}
                            </Link>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
            </div>
            {/* shoes main */}
            <div
              className={`menu-items ${
                i18n.language == "en" ? "ps-4" : `pe-4`
              }`}
            >
              <span
                className="menuhover px-0"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <Link
                  to="/products?id=WJmwaMSWxtl1dK1sPZ1x"
                  className="menu-item"
                  onClick={() => {
                    // If this filter is already active, return
                    if (activeFilter === "shoes") {
                      setHide(true);
                      return;
                    } else {
                      // If activating a new filter, set it as active and reset filters
                      setActiveFilter("shoes");
                      dispatch(SortProducts(""));
                      selectedPageNull();
                    }
                  }}
                  onMouseOver={() => setHide(false)}
                >
                  {t("Shoes")}
                </Link>
                <div
                  // dont close submenu immediately
                  style={{
                    position: "absolute",
                    top: "15px",
                    zIndex: 2,
                    paddingTop: "20px",
                  }}
                  className={` ${
                    hide == false ? "mega-menu" : ` mega-menu mega-menuCLick`
                  }`}
                  onClick={() => {
                    // If this filter is already active, return
                    if (activeFilter === "shoes") {
                      setHide(true);
                      return;
                    } else {
                      // If activating a new filter, set it as active and reset filters
                      setActiveFilter("shoes");
                      setHide(true);
                      selectedPageNull();
                    }
                  }}
                >
                  <div className="content px-md-4">
                    <div className="pt-3 pb-5 d-flex">
                      <div>
                        <Link
                          to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "shoes") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("shoes");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Designers")}
                        </Link>
                        {/* shoes designers */}
                        <div className="subtitlemega pt-4">
                          {ShoesDesigners.map((brandsection) => (
                            <>
                              {brands
                                .filter(
                                  (brand) => brand.name == brandsection.name
                                )
                                .map((brand) => (
                                  <div className="subtitlemega pb-3">
                                    <Link
                                      to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&brand=${brand.id}&nameBrand=${brand.name}`}
                                      className="subtitlemega "
                                      onClick={() => {
                                        // If this filter is already active, return
                                        if (activeFilter === "shoes") {
                                          setHide(true);
                                          return;
                                        } else {
                                          // If activating a new filter, set it as active and reset filters
                                          setActiveFilter("shoes");
                                          setHide(true);
                                          selectedPageNull();
                                        }
                                      }}
                                    >
                                      {i18n.language == "en"
                                        ? brand.name
                                        : brand.nameAr}
                                    </Link>
                                  </div>
                                ))}
                            </>
                          ))}
                        </div>
                        {/* <div className="subtitlemega pb-3">
                          <Link
                            to={`/products?id=WJmwaMSWxtl1dK1sPZ1x`}
                            className="subtitlemega "
                            style={{ fontFamily: "Montserrat-M500" }}
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "shoes") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("shoes");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("View All Shoes")}
                          </Link>
                        </div> */}
                      </div>
                      {/* shoes women */}
                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "shoes") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("shoes");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {/* {t("Women")} */}
                          Women's
                        </Link>
                        <div className="pt-4">
                          {SubCategory?.filter(
                            (subcat) =>
                              subcat.idTypeCategory ===
                                "WJmwaMSWxtl1dK1sPZ1x" &&
                              ShoesWomen.some(
                                (shoe) => shoe.name === subcat.name
                              )
                          )
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((sub) => (
                              <>
                                <div
                                  className="subtitlemega pb-3"
                                  onClick={() => {
                                    // If this filter is already active, return
                                    if (activeFilter === "shoes") {
                                      setHide(true);
                                      return;
                                    } else {
                                      // If activating a new filter, set it as active and reset filters
                                      setActiveFilter("shoes");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <Link
                                    to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`}
                                    className="subtitlemega "
                                  >
                                    {i18n.language == "en"
                                      ? sub.name
                                      : sub.nameAr}
                                  </Link>
                                </div>
                              </>
                            ))}
                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj&`}
                              style={{ fontFamily: "Montserrat-M500" }}
                              className="subtitlemega "
                              onClick={() => {
                                // If this filter is already active, return
                                if (activeFilter === "shoes") {
                                  setHide(true);
                                  return;
                                } else {
                                  // If activating a new filter, set it as active and reset filters
                                  setActiveFilter("shoes");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              {t("View All Women Shoes")}
                            </Link>
                          </div> */}
                        </div>
                      </div>
                      {/* shoes men */}
                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to="/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=KG3s4pPk3arcBux5ERnD&"
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "shoes") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("shoes");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {/* {t("Men")} */}
                          Men's
                        </Link>
                        <div className="pt-4">
                          {ShoesMen.map((shoes) =>
                            SubCategory.filter(
                              (subcat) => subcat.name === shoes.name
                            )
                              .sort((a, b) => (a.name > b.name ? 1 : -1))
                              .map((sub) => (
                                <div
                                  key={sub.id} // Added key to prevent React warnings
                                  className="subtitlemega pb-3"
                                  onClick={() => {
                                    // If this filter is already active, return
                                    if (activeFilter === "shoes") {
                                      setHide(true);
                                      return;
                                    } else {
                                      // If activating a new filter, set it as active and reset filters
                                      setActiveFilter("shoes");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <Link
                                    to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&subcategory=${sub.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                    className="subtitlemega"
                                  >
                                    {i18n.language === "en"
                                      ? sub.name
                                      : sub.nameAr}
                                  </Link>
                                </div>
                              ))
                          )}
                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=KG3s4pPk3arcBux5ERnD`}
                              style={{ fontFamily: "Montserrat-M500" }}
                              className="subtitlemega"
                              onClick={() => {
                                // If this filter is already active, return
                                if (activeFilter === "shoes") {
                                  setHide(true);
                                  return;
                                } else {
                                  // If activating a new filter, set it as active and reset filters
                                  setActiveFilter("shoes");
                                  setHide(true);
                                  selectedPageNull();
                                }
                              }}
                            >
                              {t("View All Men Shoes")}
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      {/* <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to="/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=uw8UHRzTK2qlgU8Y4cVc&"
                          className="titlemega"
                          onClick={() => setHide(true) & selectedPageNull()}
                        >
                          {t("Kids")}
                        </Link>
                        <div className="pt-4">
                          {SubCategory.filter(
                            (subcat) =>
                              subcat.idTypeCategory == "WJmwaMSWxtl1dK1sPZ1x" &&
                              (subcat.id == "Ajx4IbmZyd8tDPIUIWq1" ||
                                subcat.id == "29Qawt6kqsKBjKzJZURl" ||
                                subcat.id == "nngqcr84nZuxMUVQwbdZ" ||
                                subcat.id == "dhO2kQHheerGxSy5CBIE" ||
                                subcat.id == "MUMXw3hjGufq8nrZgCi3")
                          )
                            .sort((a, b) => (a.name > b.name ? 1 : -1))
                            .map((sub) => (
                              <>
                                <div
                                  className="subtitlemega pb-3"
                                  onClick={() =>
                                    setHide(true) & selectedPageNull()
                                  }
                                >
                                  <Link
                                    to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&subcategory=${sub.id}&gender=uw8UHRzTK2qlgU8Y4cVc`}
                                    className="subtitlemega "
                                  >
                                    {i18n.language == "en"
                                      ? sub.name
                                      : sub.nameAr}
                                  </Link>
                                </div>
                              </>
                            ))}
                          <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=uw8UHRzTK2qlgU8Y4cVc&`}
                              style={{ fontFamily: "Montserrat-M500" }}
                              className="subtitlemega "
                              onClick={() => setHide(true) & selectedPageNull()}
                            >
                              {t("View all kids shoes")}
                            </Link>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </span>
            </div>
            {/* watchesandjew */}
            <div
              className={`menu-items ${
                i18n.language == "en" ? "ps-4" : `pe-4`
              }`}
            >
              <span
                className="menuhover px-0  "
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <div
                  // to="/products?subcategory=kYTvn5wAxopx5jpqotC0&"
                  className="menu-item "
                  // onClick={() =>
                  //   dispatch(SortProducts("")) & selectedPageNull()
                  // }
                  onMouseOver={() => setHide(false)}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  {t("watchesandJewelry")}
                </div>
                <div
                  // dont close submenu immediately
                  style={{
                    position: "absolute",
                    top: "15px",
                    zIndex: 2,
                    paddingTop: "20px",
                  }}
                  className={` ${
                    hide == false ? "mega-menu" : ` mega-menu mega-menuCLick`
                  }`}
                  onClick={() => {
                    // If this filter is already active, return
                    if (activeFilter === "watchesandJewelry") {
                      setHide(true);
                      return;
                    } else {
                      // If activating a new filter, set it as active and reset filters
                      setActiveFilter("watchesandJewelry");
                      setHide(true);
                      selectedPageNull();
                    }
                  }}
                >
                  {/* watchesandjew watches */}
                  <div className="content px-md-4">
                    <div className="pt-3 pb-5 d-flex">
                      <div>
                        <Link
                          to={`/products?subcategory=kYTvn5wAxopx5jpqotC0&`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "watchesandJewelry") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("watchesandJewelry");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Watches")}
                        </Link>

                        <div className="subtitlemega pt-4">
                          {watchBrandsSection.map((idBrand) => (
                            <>
                              {brands
                                .filter((brand) => brand.name == idBrand.id)
                                .map((brand) => (
                                  <div className="subtitlemega pb-3">
                                    <Link
                                      to={`/products?subcategory=kYTvn5wAxopx5jpqotC0&brand=${brand.id}`}
                                      className="subtitlemega "
                                      onClick={() => {
                                        // If this filter is already active, return
                                        if (
                                          activeFilter === "watchesandJewelry"
                                        ) {
                                          setHide(true);
                                          return;
                                        } else {
                                          // If activating a new filter, set it as active and reset filters
                                          setActiveFilter("watchesandJewelry");
                                          setHide(true);
                                          selectedPageNull();
                                        }
                                      }}
                                    >
                                      {i18n.language == "en"
                                        ? brand.name
                                        : brand.nameAr}
                                    </Link>
                                  </div>
                                ))}
                            </>
                          ))}
                        </div>
                        {/* <div className="subtitlemega pb-3">
                          <Link
                            to={`/products?subcategory=kYTvn5wAxopx5jpqotC0`}
                            className="subtitlemega "
                            style={{ fontFamily: "Montserrat-M500" }}
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "watchesandJewelry") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("watchesandJewelry");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("View All Brands")}
                          </Link>
                        </div> */}
                      </div>
                      {/* watchesandjew jewlery */}
                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega `
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to={`/products?id=07kdA6cD3NDKxX8pQ7w1`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "watchesandJewelry") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("watchesandJewelry");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Jewelry")}
                        </Link>

                        <div className="subtitlemega pt-4">
                          {jewelryBrandsSection.map((idBrand) => (
                            <>
                              {brands
                                .filter((brand) => brand.name == idBrand.id)
                                .map((brand) => (
                                  <div className="subtitlemega pb-3">
                                    <Link
                                      to={`/products?id=07kdA6cD3NDKxX8pQ7w1&brand=${brand.id}`}
                                      className="subtitlemega "
                                      onClick={() => {
                                        // If this filter is already active, return
                                        if (
                                          activeFilter === "watchesandJewelry"
                                        ) {
                                          setHide(true);
                                          return;
                                        } else {
                                          // If activating a new filter, set it as active and reset filters
                                          setActiveFilter("watchesandJewelry");
                                          setHide(true);
                                          selectedPageNull();
                                        }
                                      }}
                                    >
                                      {i18n.language == "en"
                                        ? brand.name
                                        : brand.nameAr}
                                    </Link>
                                  </div>
                                ))}
                            </>
                          ))}
                        </div>
                        {/* <div className="subtitlemega pb-3">
                          <Link
                            to={`/products?id=07kdA6cD3NDKxX8pQ7w1`}
                            className="subtitlemega "
                            style={{ fontFamily: "Montserrat-M500" }}
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "watchesandJewelry") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("watchesandJewelry");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("View All Brands")}
                          </Link>
                        </div> */}
                      </div>

                      {/* <div className={`  ${i18n.language=="en"?`padding-sectionmega`:`padding-sectionmegaAr`}`}>
           
        
       
           
            <div className="subtitlemega pt-5">
                <div className="pt-2">
                {ModelSection2.map((model)=>
                <>
                
                    <div  className="subtitlemega pb-3 ">
                    <Link to={`/products?model=${model.name.toLowerCase()}`}  className="subtitlemega " onClick={()=>setHide(true)&selectedPageNull()}>
                    {model.name}
                    </Link>
                    </div>
             
                </>
                )
                
                
            }
           </div>
            </div>
            </div> */}
                      {/* watchesandjew women */}

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to={`/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=WFA967se7qX0jYtySgTj&`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "watchesandJewelry") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("watchesandJewelry");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {/* {t("Women")} */}
                          Women's
                        </Link>
                        <div className="pt-4">
                          {/* {SubCategory.filter(
                            (subcat) =>
                              subcat.idTypeCategory == "AqFLulu9y2m4mqEIkch1"
                          )
                            .sort((a, b) => (a.name > b.name ? 1 : -1)) */}
                          {womenJewelryWatch.map((sub) => (
                            <>
                              <div
                                className="subtitlemega pb-3"
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "watchesandJewelry") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("watchesandJewelry");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <Link to={sub.params} className="subtitlemega ">
                                  {i18n.language == "en"
                                    ? sub.name
                                    : sub.nameAr}
                                </Link>
                              </div>
                            </>
                          ))}
                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj&`}
                              style={{ fontFamily: "Montserrat-M500" }}
                              className="subtitlemega "
                              onClick={() => setHide(true) & selectedPageNull()}
                            >
                              {t("View All Women Bags")}
                            </Link>
                          </div> */}
                        </div>
                      </div>
                      {/* watchesandjew men */}
                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to={`/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=KG3s4pPk3arcBux5ERnD&`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "watchesandJewelry") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("watchesandJewelry");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {/* {t("Men")} */}
                          Men's
                        </Link>
                        <div className="pt-4">
                          {menJewelryWatch.map((sub) => (
                            <>
                              <div
                                className="subtitlemega pb-3"
                                onClick={() => {
                                  // If this filter is already active, return
                                  if (activeFilter === "watchesandJewelry") {
                                    setHide(true);
                                    return;
                                  } else {
                                    // If activating a new filter, set it as active and reset filters
                                    setActiveFilter("watchesandJewelry");
                                    setHide(true);
                                    selectedPageNull();
                                  }
                                }}
                              >
                                <Link to={sub.params} className="subtitlemega ">
                                  {i18n.language == "en"
                                    ? sub.name
                                    : sub.nameAr}
                                </Link>
                              </div>
                            </>
                          ))}
                          {/* <div className="subtitlemega pb-3">
                            <Link
                              to={`/products?id=AqFLulu9y2m4mqEIkch1&gender=KG3s4pPk3arcBux5ERnD&`}
                              style={{ fontFamily: "Montserrat-M500" }}
                              className="subtitlemega "
                              onClick={() => setHide(true) & selectedPageNull()}
                            >
                              {t("View All Men Bags")}
                            </Link>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
            </div>
            {/* children main */}
            <div
              className={`menu-items ${
                i18n.language == "en" ? "ps-4" : `pe-4`
              }`}
            >
              <span
                className="menuhover px-0  "
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <Link
                  to="/products?gender=uw8UHRzTK2qlgU8Y4cVc&"
                  className="menu-item"
                  onClick={() => {
                    // If this filter is already active, return
                    if (activeFilter === "children") {
                      setHide(true);
                      return;
                    } else {
                      // If activating a new filter, set it as active and reset filters
                      setActiveFilter("children");
                      dispatch(SortProducts(""));
                      selectedPageNull();
                    }
                  }}
                  onMouseOver={() => setHide(false)}
                >
                  {t("Kids")}
                </Link>
                <div
                  // dont close submenu immediately
                  style={{
                    position: "absolute",
                    top: "15px",
                    zIndex: 2,
                    paddingTop: "20px",
                  }}
                  className={` ${
                    hide == false ? "mega-menu" : ` mega-menu mega-menuCLick`
                  }`}
                  onClick={() => {
                    // If this filter is already active, return
                    if (activeFilter === "children") {
                      setHide(true);
                      return;
                    } else {
                      // If activating a new filter, set it as active and reset filters
                      setActiveFilter("children");
                      setHide(true);
                      selectedPageNull();
                    }
                  }}
                >
                  <div className="content px-md-4">
                    <div className="pt-3 pb-5 d-flex">
                      <div>
                        <Link
                          to={`/products?id=yJDeEt0uKPxfxtqOM42V&gender=tTwOQNL4etSBiJy0j5zY&`}
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "children") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("children");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Girls clothes")}
                        </Link>

                        <div className="subtitlemega pt-4">
                          {childgirlclothes?.map((brand) => (
                            <>
                              <div className="subtitlemega pb-3">
                                <Link
                                  to={brand.params}
                                  className="subtitlemega "
                                  onClick={() => {
                                    // If this filter is already active, return
                                    if (activeFilter === "children") {
                                      setHide(true);
                                      return;
                                    } else {
                                      // If activating a new filter, set it as active and reset filters
                                      setActiveFilter("children");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  {i18n.language == "en"
                                    ? brand.name
                                    : brand.nameAr}
                                </Link>
                              </div>
                            </>
                          ))}
                        </div>
                        {/* <div className="subtitlemega pb-3">
                          <Link
                            // to={`/products?gender=tTwOQNL4etSBiJy0j5zY`}
                            to={`/products?id=yJDeEt0uKPxfxtqOM42V&gender=tTwOQNL4etSBiJy0j5zY&`}
                            className="subtitlemega "
                            style={{ fontFamily: "Montserrat-M500" }}
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "children") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("children");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("view-all")}
                          </Link>
                        </div> */}
                      </div>
                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to="/products?id=yJDeEt0uKPxfxtqOM42V&gender=btauY7skTre33RbhtagD&"
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "children") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("children");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Boys clothes")}
                        </Link>
                        <div className="subtitlemega pt-4">
                          {childboys?.map((brand) => (
                            <>
                              <div className="subtitlemega pb-3">
                                <Link
                                  to={brand.params}
                                  className="subtitlemega "
                                  onClick={() => {
                                    // If this filter is already active, return
                                    if (activeFilter === "children") {
                                      setHide(true);
                                      return;
                                    } else {
                                      // If activating a new filter, set it as active and reset filters
                                      setActiveFilter("children");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  {i18n.language == "en"
                                    ? brand.name
                                    : brand.nameAr}
                                </Link>
                              </div>
                            </>
                          ))}
                        </div>
                        {/* <div className="subtitlemega  pb-3">
                          <Link
                            // to="/products?gender=btauY7skTre33RbhtagD&"
                            to="/products?id=yJDeEt0uKPxfxtqOM42V&gender=btauY7skTre33RbhtagD&"
                            style={{ fontFamily: "Montserrat-M500" }}
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "children") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("children");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("view-all")}
                          </Link>
                        </div> */}
                      </div>

                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to="/products?gender=zw8UHRzTK2qlgU8Y4cVc&"
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "children") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("children");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("Baby")}
                        </Link>
                        <div className="subtitlemega pt-4">
                          {baby?.map((brand) => (
                            <>
                              <div className="subtitlemega pb-3">
                                <Link
                                  to={brand.params}
                                  className="subtitlemega "
                                  onClick={() => {
                                    // If this filter is already active, return
                                    if (activeFilter === "children") {
                                      setHide(true);
                                      return;
                                    } else {
                                      // If activating a new filter, set it as active and reset filters
                                      setActiveFilter("children");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  {i18n.language == "en"
                                    ? brand.name
                                    : brand.nameAr}
                                </Link>
                              </div>
                            </>
                          ))}
                        </div>
                        {/* <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?gender=zw8UHRzTK2qlgU8Y4cVc&"
                            style={{ fontFamily: "Montserrat-M500" }}
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "children") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("children");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("view-all")}
                          </Link>
                        </div> */}
                      </div>
                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          // to="/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=uw8UHRzTK2qlgU8Y4cVc&"
                          to="/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=uw8UHRzTK2qlgU8Y4cVc&"
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "children") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("children");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("ChildrenShoes")}
                        </Link>
                        <div className="subtitlemega pt-4">
                          {childrenShoes.map((brand) => (
                            <>
                              <div className="subtitlemega pb-3">
                                <Link
                                  to={brand.params}
                                  className="subtitlemega "
                                  onClick={() => {
                                    // If this filter is already active, return
                                    if (activeFilter === "children") {
                                      setHide(true);
                                      return;
                                    } else {
                                      // If activating a new filter, set it as active and reset filters
                                      setActiveFilter("children");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  {i18n.language == "en"
                                    ? brand.name
                                    : brand.nameAr}
                                </Link>
                              </div>
                            </>
                          ))}
                        </div>
                        {/* <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=uw8UHRzTK2qlgU8Y4cVc&"
                            style={{ fontFamily: "Montserrat-M500" }}
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "children") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("children");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("view-all")}
                          </Link>
                        </div> */}
                      </div>
                      <div
                        className={` ${
                          i18n.language == "en"
                            ? `padding-sectionmega`
                            : `padding-sectionmegaAr`
                        }`}
                      >
                        <Link
                          to="/products?id=AqFLulu9y2m4mqEIkch1&gender=uw8UHRzTK2qlgU8Y4cVc&"
                          className="titlemega"
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "children") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("children");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          {t("BagsAccessories")}
                        </Link>
                        <div className="subtitlemega pt-4">
                          {childrenBagsAcc?.map((brand) => (
                            <>
                              <div className="subtitlemega pb-3">
                                <Link
                                  to={brand.params}
                                  className="subtitlemega "
                                  onClick={() => {
                                    // If this filter is already active, return
                                    if (activeFilter === "children") {
                                      setHide(true);
                                      return;
                                    } else {
                                      // If activating a new filter, set it as active and reset filters
                                      setActiveFilter("children");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  {i18n.language == "en"
                                    ? brand.name
                                    : brand.nameAr}
                                </Link>
                              </div>
                            </>
                          ))}
                        </div>
                        {/* <div className="subtitlemega  pb-3">
                          <Link
                            to="/products?id=AqFLulu9y2m4mqEIkch1&gender=uw8UHRzTK2qlgU8Y4cVc&"
                            style={{ fontFamily: "Montserrat-M500" }}
                            className="subtitlemega  "
                            onClick={() => {
                              // If this filter is already active, return
                              if (activeFilter === "children") {
                                setHide(true);
                                return;
                              } else {
                                // If activating a new filter, set it as active and reset filters
                                setActiveFilter("children");
                                setHide(true);
                                selectedPageNull();
                              }
                            }}
                          >
                            {t("view-all")}
                          </Link>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </span>
            </div>
            <div
              className={`menu-items ${
                i18n.language == "en" ? "ps-4" : `pe-4`
              }`}
            >
              <span
                className="menuhover px-0  "
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <Link
                  to="/products?topic=pricedrops&"
                  className="menu-item"
                  onClick={() => {
                    // If this filter is already active, return
                    if (activeFilter === "sale") {
                      setHide(true);
                      return;
                    } else {
                      // If activating a new filter, set it as active and reset filters
                      setActiveFilter("sale");
                      dispatch(SortProducts(""));
                      selectedPageNull();
                    }
                  }}
                  onMouseOver={() => setHide(false)}
                  style={{ color: "#BC1010" }}
                >
                  {t("Sale")}
                </Link>
              </span>
            </div>
          </div>
          <hr className="mx-4  mt-1" />
        </nav>
      </header>
    </>
  );
}

export default MegaMenu;
